export default function HoverFace() {
  return (
    <img src={process.env.PUBLIC_URL + "/images/02YesHover00.jpg"} alt="" />
  );
}
